import { render, staticRenderFns } from "./DayFastNewsList.vue?vue&type=template&id=946f9e96&scoped=true"
import script from "./DayFastNewsList.vue?vue&type=script&lang=js"
export * from "./DayFastNewsList.vue?vue&type=script&lang=js"
import style0 from "./DayFastNewsList.vue?vue&type=style&index=0&id=946f9e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946f9e96",
  null
  
)

export default component.exports